import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import { messageNotification } from 'helpers';
import { getSiteIndexInfo, updateSiteIndexingToogle } from 'services/appearance';
import SettingsLoader from 'components/loaders/SettingsLoader';

const SiteIndexToogle = () => {
  const [isSiteIndexToogle, setisSiteIndexToogle] = useState(null);

  useEffect(() => {
    getSiteIndexInfo()
      .then((response) => {
        const siteIndexToggle = response?.data?.data?.is_blog_public === '0' ? true : false;
        setisSiteIndexToogle(siteIndexToggle);
      })
      .catch((err) => {
        messageNotification('danger', 'Error', `${err}`);
      });
  }, []);

  const toggleSiteIndexFlag = () => {
    const newSiteIndexToogle = !isSiteIndexToogle;
    const wp_json_data = {
      is_site_public: newSiteIndexToogle
    };

    updateSiteIndexingToogle(wp_json_data)
      .then((res) => {
        messageNotification(
          'success',
          'Site Index flag updated',
          'The site indexing flag has been updated successfully'
        );
        setisSiteIndexToogle(newSiteIndexToogle);
      })
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
      });
  };

  return isSiteIndexToogle !== null ? (
    <div className="subheader-holder mt-5">
      <h4>Search engine visibility</h4>
      <p>It is up to search engines to honor this request</p>
      <div className="custom-control d-flex align-items-start custom-checkbox course-activity-filter">
        <Form.Check
          label="Discourage search engines from indexing this site"
          id="siteIndexToogle"
          type="checkbox"
          onChange={toggleSiteIndexFlag}
          checked={isSiteIndexToogle}
        />
      </div>
    </div>
  ) : (
    <SettingsLoader />
  );
};

export default SiteIndexToogle;
